export default {
  philter: "[type]-card"
};
